import { useState, useCallback } from 'react';

export const useSidebarResize = (initialWidth = 400, minWidth = 300, maxWidth = 800) => {
    const [width, setWidth] = useState(initialWidth);

    const handleMouseDown = useCallback((e) => {
        const startX = e.clientX;
        const startWidth = width;

        const onMouseMove = (moveEvent) => {
            // Calculate new width based on drag (assuming sidebar is on the right)
            const newWidth = startWidth + (startX - moveEvent.clientX);
            if (newWidth >= minWidth && newWidth <= maxWidth) {
                setWidth(newWidth);
            }
        };

        const onMouseUp = () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }, [width, minWidth, maxWidth]);

    return { width, handleMouseDown };
};